import React, { useState, useEffect } from "react";

export default function CountdownToDate({ targetDate, title = "Event" }) {
  const calculateTimeLeft = () => {
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return null;
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [flicker, setFlicker] = useState({ days: false, hours: false, minutes: false });

  useEffect(() => {
    const prevTime = { ...timeLeft };

    const timer = setInterval(() => {
      const newTime = calculateTimeLeft();
      if (!newTime) {
        clearInterval(timer);
        setTimeLeft(null);
        return;
      }

      setFlicker({
        days: prevTime.days !== newTime.days,
        hours: prevTime.hours !== newTime.hours,
        minutes: prevTime.minutes !== newTime.minutes,
      });

      setTimeout(() => setFlicker({ days: false, hours: false, minutes: false }), 200);

      Object.assign(prevTime, newTime);
      setTimeLeft(newTime);
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (!timeLeft) return null;

  const flickerStyle = { opacity: 0.2 }; // flicker effect

  return (
    <div className="countdown" style={{fontFamily: "monospace" }}>
      <div style={{ fontSize: "1rem" }}>
        <span style={flicker.days ? flickerStyle : {}}>{timeLeft.days}d </span>
        <span style={flicker.hours ? flickerStyle : {}}>{timeLeft.hours}h </span>
        <span style={flicker.minutes ? flickerStyle : {}}>{timeLeft.minutes}m</span>
      </div>
      <div style={{ fontSize: ".8rem", marginBottom: "0.5rem" }}>{`Countdown to ${title}`}</div>      
    </div>
  );
}
